import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch,useAppSelector } from '../../../app/hooks';
import { deleteAccountWorkingDayTypeAsync, getAccountWorkingDayTypeByAccountWorkingDayTypeIdAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting } from './workingdaytypeSlice';
import clsx from 'clsx';
import { ShowToast } from '../../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { FormatInvoiceDecimalNumber, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const WorkingDayTypeItem = (props: any) => {
    const { workingdaytypeList, t, IsEdit, IsDelete } = props;
    console.log('workingdaytypeList',workingdaytypeList)
    const { sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.workingdaytype);
    const { manageTerminologyList, cultureInfoName, decimalFormat, decimalPlaces } = useAppSelector((state) => state.globalState);

    const dispatch = useAppDispatch();


    const onDeleteClick = (AccountWorkingDayTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountWorkingDayTypeAsync(AccountWorkingDayTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Working Day Type deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {

                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountWorkingDayTypeId: number) => {
        dispatch(getAccountWorkingDayTypeByAccountWorkingDayTypeIdAsync(AccountWorkingDayTypeId))
            .unwrap()
            .then((originalPromiseResult) => {


            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
            <thead>
                <tr className="thHeading align-middle "  >
                <th style={{width:'15%'}}>
                    {/* {t('Working Day Type')} */}
                    {getValueFromResource('Working Day Type',dispatch, t)}
                    {sortColumn === 'AccountWorkingDayType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountWorkingDayType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountWorkingDayType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountWorkingDayType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountWorkingDayType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                    </th>
                    <th style={{width:'10%', textAlign:'center'}}>
                        {/* {t('Week Start Day')}  */}
                        {getValueFromResource('Week Start Day',dispatch, t)}
                        {sortColumn === 'WeekStartDay' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "WeekStartDay") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "WeekStartDay") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "WeekStartDay") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "WeekStartDay") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'10%', textAlign:'center'}}>
                                    {/* {t('Hours Per Day')} */}
                                    {getValueFromResource('Hours Per Day',dispatch, t)}
                                     {sortColumn === 'HoursPerDay' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "HoursPerDay") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "HoursPerDay") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "HoursPerDay") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "HoursPerDay") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'10%', textAlign:'center'}}>
                                    {/* {t('Maximum Hours Per Day')}  */}
                                    {getValueFromResource('Minimum Hours Per Day',dispatch, t)}
                                    {sortColumn === 'MinimumHoursPerDay' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MinimumHoursPerDay") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MinimumHoursPerDay") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "MinimumHoursPerDay") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "MinimumHoursPerDay") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'10%', textAlign:'center'}}>
                                    {/* {t('Maximum Hours Per Day')} */}
                                    {getValueFromResource('Maximum Hours Per Day',dispatch, t)}
                                    {sortColumn === 'MaximumHoursPerDay' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MaximumHoursPerDay") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MaximumHoursPerDay") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "MaximumHoursPerDay") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "MaximumHoursPerDay") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'11%', textAlign:'center'}}>
                                    {/* {t('Minimum Hours Per Period')} */}
                                    {getValueFromResource('Minimum Hours Per Period',dispatch, t)}
                                     {sortColumn === 'MinimumHoursPerWeek' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MinimumHoursPerWeek") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MinimumHoursPerWeek") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "MinimumHoursPerWeek") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "MinimumHoursPerWeek") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'11%', textAlign:'center'}}>
                                    {/* {t('Maximum Hours Per Period')} */}
                                    {getValueFromResource('Maximum Hours Per Period',dispatch, t)}
                                     {sortColumn === 'MaximumHoursPerWeek' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MaximumHoursPerWeek") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MaximumHoursPerWeek") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "MaximumHoursPerWeek") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "MaximumHoursPerWeek") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'10%', textAlign:'center'}}>
                                    {/* {t('Overdue After Days')}  */}
                                    {getValueFromResource('Overdue After Days',dispatch, t)}
                                    {sortColumn === 'TimesheetOverdueAfterDays' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TimesheetOverdueAfterDays") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TimesheetOverdueAfterDays") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TimesheetOverdueAfterDays") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TimesheetOverdueAfterDays") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {workingdaytypeList.length === 0 && <tr><td colSpan={9}><p className='noDataFound'>
                    {/* {t('No Record Found')} */}
                    {getValueFromResource('No Record Found',dispatch, t)}
                    </p></td></tr>}
                {workingdaytypeList.length > 0 && workingdaytypeList.map((workingdaytypeDetail: any, i: any) => (

                    <tr>
                        <td id={`${IsEdit ? 'kt_OffCanvas' : ''}`} className='text-gray-800  text-hover-primary custom-pointer-cursor '
                            onClick={IsEdit ? () => onEditClick(workingdaytypeDetail.AccountWorkingDayTypeId) : undefined}
                        >
                            <span className="d-block">
                                {workingdaytypeDetail.AccountWorkingDayType}
                            </span>
                        </td>
                        <td>
                            <span className="d-block text-center">
                                {workingdaytypeDetail.WeekStartDay}
                            </span>
                        </td>
                        <td>
                            <span className="d-block text-center">
                                 {/* {workingdaytypeDetail.HoursPerDay} */}
                                {FormatInvoiceDecimalNumber(cultureInfoName.toString(), workingdaytypeDetail.HoursPerDay,2)}
                            </span>
                        </td>
                        <td>
                            <span className="d-block text-center">
                                 {/* {workingdaytypeDetail.MinimumHoursPerDay} */}
                                {FormatInvoiceDecimalNumber(cultureInfoName.toString(), workingdaytypeDetail.MinimumHoursPerDay,2)}                               
                            </span>
                        </td>
                        <td>
                            <span className="d-block text-center">
                                {/* {workingdaytypeDetail.MaximumHoursPerDay} */}
                                {FormatInvoiceDecimalNumber(cultureInfoName.toString(), workingdaytypeDetail.MaximumHoursPerDay,2)}  
                            </span>
                        </td>
                        <td>
                            <span className="d-block text-center">
                                {/* {workingdaytypeDetail.MinimumHoursPerWeek} */}
                                {FormatInvoiceDecimalNumber(cultureInfoName.toString(), workingdaytypeDetail.MinimumHoursPerWeek,2)}  
                            </span>
                        </td>
                        <td>
                            <span className="d-block text-center">
                                {/* {workingdaytypeDetail.MaximumHoursPerWeek} */}
                                 {FormatInvoiceDecimalNumber(cultureInfoName.toString(), workingdaytypeDetail.MaximumHoursPerWeek,2)} 
                            </span>
                        </td>
                        <td>
                            <span className="d-block text-center">
                                {workingdaytypeDetail.TimesheetOverdueAfterDays}
                            </span>
                        </td>
                        <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        id="kt_OffCanvas"
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => onEditClick(workingdaytypeDetail.AccountWorkingDayTypeId)}
                                                    >
                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {/* {`${t('Edit')}`} */}
                                                            {getValueFromResource('Edit',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                        {IsDelete && IsEdit && (workingdaytypeDetail.MasterWorkingDayTypeId === null || workingdaytypeDetail.MasterWorkingDayTypeId === "") &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }
                                        {IsDelete && (workingdaytypeDetail.MasterWorkingDayTypeId === null || workingdaytypeDetail.MasterWorkingDayTypeId === "") &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onDeleteClick(workingdaytypeDetail.AccountWorkingDayTypeId) }}
                                                    >
                                                        <span className="menu-icon  custom-menu">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default WorkingDayTypeItem;